import { faWarning } from "@fortawesome/free-solid-svg-icons";
import Button from "components/components/Button/Button";
import Icon from "components/components/Icon/Icon";
import { IconSize } from "components/components/Icon/IconWrapper";
import Modal, { ModalSize } from "components/components/Modal/Modal";
import React from "react";

import { ContentContainer } from "./style";

type Props = {
  isActive: boolean;
  close: () => void;
};

const MaximumQueueReachedModal: React.FC<Props> = ({ isActive, close }) => (
  <Modal size={ModalSize.medium} isActive={isActive} onClose={close}>
    <div aria-live="polite">
      <ContentContainer>
        <Icon iconName={faWarning} colour="darkOrange" size={IconSize.xLarge} />
        <h1>Maximum number of queues reached</h1>
        <p>
          You have reached the limit of 10 queues associated with your account.{" "}
          <strong>
            Please delete an existing queue before trying to create a new one.
          </strong>
        </p>
        <hr />
        <Button ariaLabel="Close" buttonText="Close" onClick={close} />
      </ContentContainer>
    </div>
  </Modal>
);

export default MaximumQueueReachedModal;
